import { render, staticRenderFns } from "./AddEditDriver.vue?vue&type=template&id=dffc990c&scoped=true&"
import script from "./AddEditDriver.vue?vue&type=script&lang=js&"
export * from "./AddEditDriver.vue?vue&type=script&lang=js&"
import style0 from "./AddEditDriver.vue?vue&type=style&index=0&id=dffc990c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffc990c",
  null
  
)

export default component.exports